var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "back",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 6 11.0054388",
    style: {
      enableBackground: "new 0 0 6 11.0054388"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8489232,0.1456475L5.854362,5.1510863c0.1941843,0.1941843,0.1941838,0.5090685-0.0000005,0.7032528 l-5.0054383,5.0054383c-0.1942272,0.1942272-0.5090685,0.1941843-0.7032528,0c-0.1942272-0.1942272-0.1942272-0.5090256,0-0.7032528 l4.6538124-4.6538119L0.1456704,0.8489003c-0.1942272-0.1942272-0.1942272-0.5090255,0-0.7032527 C0.3398547-0.0485367,0.654696-0.0485796,0.8489232,0.1456475z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRight);
export default __webpack_public_path__ + "static/media/BtnRight.a0c05d0f90ce0ad56386e8ca46217959.svg";
export { ForwardRef as ReactComponent };